import { t } from '@/i18n/utils'

/**
 * Contact Us 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  get feedbackTitle() { return t('Feedback') },
  get feedbackPlaceholder() { return t('Feedback') },
  get emailTitle() { return t('EnterYourEmail') },
  get emailPlaceholder() { return t('EnterYourEmail') },
  get submitButton() { return t('Submit') },
  // 与 en.json 不完全匹配
  get submittingButton() { return t('submittingButton') },
  get successToast() { return t('Success') },
  // 与 en.json 不完全匹配
  get failToast() { return t('failToast') },
  get emailErrorToast() { return t('EmailNotInput') },
} as const
